import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <RankingSection />
        <MediaSection />
        <ContactSection />
        <TopicsSection />
        <CommentsSection />
        <AboutSection />
        <UpdatesSection />
        <CarouselSection />
        <IndexSection />
        <FeaturesSection />
        <AppSection />
        <CardsSection />
      </main>
      <Footer />
    </div>
  );
}